import './contact.css';

import Form from '../../../components/forms/form';

import BackgroundImg from '../../../components/backgroundImg/backgroundImg';
import ContactBackground from '../../../assets/sectionBackgrounds/contactBackground/contactBackground';


export default function Contact({isMobile}) {
    return(
        <div className="contact">
            <div className="contact-container">
                <BackgroundImg background={<ContactBackground isMobile={isMobile}/>}/>

                <div className="contact-content">
                    <Form 
                    submitType={'handleContact'}
                    formTag={'handleContactSubmit'} 
                    titleTag={'Lets get in touch!'}
                    nameTag={true}
                    emailTag={true}
                    subjectTag={true}
                    messageTag={true}/>
                </div>
                
            </div>
        </div>
    )
};